import { BreadcrumbModel } from './breadcrumb.interface';
export class BreadcrumbService {
  processBreadcrumbsForDisplay = (breadcrumbs: BreadcrumbModel[], breadcrumbNumber: number) => {
    let breadcrumbsList = [];

    if (breadcrumbs.length > breadcrumbNumber) {
      for (let i = breadcrumbs.length - 1; i >= 0 && breadcrumbsList.length < breadcrumbNumber; i--) {
        breadcrumbsList.unshift(breadcrumbs[i]);
      }
    } else {
      breadcrumbsList = breadcrumbs;
    }

    let lastCrumb = breadcrumbsList[breadcrumbsList.length - 1];
    lastCrumb = { ...lastCrumb, routerLink: null };
    breadcrumbsList.pop();
    breadcrumbsList.push(lastCrumb);
    return breadcrumbsList;
  };
}
